<template>
  <div class="page-box">
    <div class="state-ul">
      <div class="state-li" v-for="(item, index) in List" :key="index" :class="{ active: active === item.value }" @click="setActive(item.value)">{{ item.name }}</div>
    </div>
    <div class="study-box">
      <template v-if="active != 'GUIDE_CONSENSUS' && active != 'NOTICE'">
        <NewsList :list2="showList" :active="active" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
      </template>
      <template v-if="active == 'NOTICE'">
        <forumTwo :list="showList" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
      </template>
      <template v-if="active == 'GUIDE_CONSENSUS'">
        <guide :guide="showList" :active="active" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
      </template>
    </div>
  </div>
</template>

<script>
import NewsList from "@/views/PersonalCenter/components/NewsList.vue";
import { getUserCollect } from '@/api/user'
import { getCollectForum } from '@/api/forum'
import guide from "@/components/guide/index.vue";
import forumTwo from "@/views/ForumCenter/components/forumTwo.vue";

export default {
  name: "LearningProgress",
  components: {
    NewsList,
    guide,
    forumTwo
  },
  data() {
    return {
      active: 'NEWS',
      List: [
        {
          name: '新闻资讯',
          value: 'NEWS',
        },
        {
          name: '质控课程',
          value: 'COURSE',
        },
        {
          name: '指南共识',
          value: 'GUIDE_CONSENSUS',
        },
        {
          name: '科普知识',
          value: 'SCIENCE',
        },
        {
          name: '“向错误学习”平台',
          value: 'NOTICE',
        },
      ],
      showList: [],
      page: {
        number: 1,
        limit: 10,
        total: 0,
      }
    }
  },
  methods: {
    setActive(index) {
      this.active = index;
      this.page.number = 1
      this.Initialization()
    },
    // 分页查询我的收藏
    getUserCollect() {
      getUserCollect({
        number: this.page.number,
        limit: this.page.limit,
        categories: this.active,
      }).then(res => {
        this.showList = res.data
        this.page.total = res.totalCount
      })
    },
    getCollectForum() {
      getCollectForum({
        number: this.page.number,
        limit: this.page.limit,
      }).then(res => {
        this.showList = res.data
        this.page.total = res.totalCount
      })
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.Initialization()
    },
    currentChange(value) {
      this.page.number = value
      this.Initialization()
    },
    // 初始化
    Initialization() {
      if (this.active != 'NOTICE' && this.active != 'Live_broadcast') {
        this.getUserCollect()
      } else if (this.active == 'NOTICE') {
        this.getCollectForum()
      } else if (this.active == 'Live_broadcast') {
        this.getLiveManagement()
      }
    }
  },
  mounted() {
    this.Initialization()
  }
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/MyCollection.vue